import { VacationYtdAdjustmentHistory } from '@app/models/payroll/vacation-ytd-adjustment-history';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { BadgeDisplay } from '@app/modules/table/interfaces/badge-display.interface';

export class TimeOffMoneyBalanceColumn extends Column {
    title = 'Balance';
    property = 'timeOffMoneyBalanceYtd';
    type: CellDisplay = CellDisplay.string;

    getBadgeDisplay(vacationYtdAdjustmentHistory: VacationYtdAdjustmentHistory): BadgeDisplay | undefined {
        if (!vacationYtdAdjustmentHistory.processed) {
            return {
                type: 'warning',
                label: 'PENDING',
            };
        }
        return;
    }

    getDisplayPropertyValue(vacationYtdAdjustmentHistory: VacationYtdAdjustmentHistory): string {
        if (!vacationYtdAdjustmentHistory.processed) {
            return;
        }
        if (vacationYtdAdjustmentHistory.timeOffMoneyBalanceYtd) {
            if (vacationYtdAdjustmentHistory.timeOffMoneyBalanceYtd.includes('-')) {
                const strippedDollarAmount = vacationYtdAdjustmentHistory.timeOffMoneyBalanceYtd.replace('-', '');
                return '-$' + strippedDollarAmount;
            }
            return '$' + vacationYtdAdjustmentHistory.timeOffMoneyBalanceYtd;
        }
        return '-';
    }
}
